<template>
  <div class="intro-content">
    <v-container>

      <!-- Page 2 -->
      <h1 style="text-align:left">{{ head2 }}</h1>
      <ul class="indented2">
				<li>{{ list2_0 }}</li>
        <li>{{ list2_1 }}</li>
				<li>{{ list2_22 }}</li>
        <li>{{ list2_2 }}</li>
        <li>{{ list2_3 }}</li>
        <li>{{ list2_4 }}</li>
        <li>{{ list2_5 }}</li>
      </ul>
			<div class="listhead">Notes on Deobligations</div>
				<ul class="indented2">
					<li>{{ list3_1 }}</li>
					<li>{{ list3_2 }}</li>
				</ul>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {

      head2: "How Should I Report My Data?",
			list2_0: "Report total (gross) obligations; do not report net of deobligations. The Data uses from the policy community which has included. The Office of Science and Technology Policy  and the Congressional Research Service, among others, had requested the survey measure total obligations made in the current fiscal year and not adjust for deobligations from previous years’ funds. (See also below.)",
      list2_1: "Report actual dollars for all amounts. However, you can enter only whole dollars. This means that there are sometimes $1 or $2 differences between the totals on different tables. You will need to adjust your amounts to match the cross-referenced numbers.",
			list2_22: "The survey does not accept negative amounts.",
      list2_2:
        "Where possible, use enacted appropriation rather than annualized continuing resolution amounts.",
      list2_3:
        "R&D outlays and obligations reported in this survey should be consistent with amounts in the Budget of the United States Government. See OMB Circular A-11, Section 84.3(g). The same definitions are used for both.",
      list2_4:
        "Report all outlays or obligations that occurred in FY 2024, and those estimated for FY 2025. The FY 2025 estimates will be collected again on next year’s survey as final outlays and obligations with the FY 2026 estimates.",
      list2_5:
        "Report the fiscal year in which the outlay or obligation was made regardless of when the funds were originally authorized, received, or appropriated.",
			list3_1:
				"Do not adjust for deobligations. For this survey, agencies should report the total amounts obligated without any adjustment for deobligations. The only place to account for deobligations is Question 4.",
			list3_2:
				"While agencies may prefer to report R&D and R&D plant net of deobligations, the data collected for this survey are for statistical purposes and should not be treated as equivalent to a financial statement or audit, as such survey results will differ from financial accounting statements."
    };
  }
};
</script>

<style scoped>
h1 {
  font-size: 22pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
h2 {
  font-size: 20pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
h3 {
  font-size: 18pt;
  font-weight: bold;
  margin-left: 12pt;
}
.indented1 {
  margin-left: 25pt;
  font-weight: normal;
}
.indented2 {
  margin-left: 50pt;
  font-weight: normal;
}
.indented2under {
  margin-left: 50pt;
  font-weight: normal;
  text-decoration-line: underline;
}
.bold {
  font-weight: bold;
}
.italics {
  font-style: italic;
}
.normal {
  font-weight: normal;
}
.listhead {
  text-align: left;
  text-decoration-line: underline;
  font-size: larger;
  margin-bottom: 10pt;
}
.left {
  text-align: left;
}
.centered {
  text-align: center;
}
ul,
p {
  text-align: left;
}
p,
li {
  font-size: 12pt;
}
li {
  margin-bottom: 10pt;
}
.intro-content {
  color: #000;
  max-width: 750px; /* TODO: discuss w/team; make a global */
}
.bordered {
  border: #000;
  border: 1px solid;
}
.header {
  font-weight: bold;
  color: #13314f;
  font-size: 14px;
  margin: 0;
}
table {
  background-color: aliceblue;
  width: 100%;
  text-align: left;
  border-spacing: 0;
  border: 1px solid black;
  border-collapse: collapse;
}
th {
  text-align: center;
  border: 1px solid black;
  padding: 15px;
}
.marginleft {
  margin-left: 5px;
}
td {
  border: 1px solid black;
  padding: 10px;
}
td.center {
  text-align: center;
  border: 1px solid black;
}
</style>
